"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _goodsListActive = require("@/api/operationManagement/goodsListActive");
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['itemDetail'],
  data: function data() {
    return {
      goodsActivity: {},
      goodsList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    // console.log(this.$props.itemDetail)
    (0, _customPage.moduleDetail)({
      moduleId: this.$props.itemDetail.moduleId
    }).then(function (res) {
      if (res.data && res.data != null) {
        _this.goodsActivity = res.data.goodsActivity;
      }
    }).then(function () {
      (0, _goodsListActive.queryGoods)({
        platformCode: _this.goodsActivity.platformCode,
        activityId: _this.goodsActivity.activityId,
        limit: 6,
        pageNo: 1
      }).then(function (res) {
        res.data.data.map(function (i) {
          i.goodsDetail = JSON.parse(i.goodsDetail);
        });
        _this.goodsList = res.data.data;
        console.log(res.data.data, '商品哦');
      });
    });
  },
  methods: {}
};